export default "__VITE_ASSET__BdePpDO0__"